module.exports = __webpack_public_path__ + "img/success1.4a06f9d8.png";